import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { textSans, neutral } from '@guardian/source-foundations';
const fieldLabelStyles = css `
	${textSans.medium({ fontWeight: 'bold' })}
`;
const fieldDescription = css `
	${textSans.medium()}
`;
const optionalTextStyles = css `
	${textSans.small({ fontStyle: 'italic' })}
	color: ${neutral[46]};
	padding-left: 5px;
`;
export const FieldLabel = ({ formField }) => (_jsxs("label", Object.assign({ css: fieldLabelStyles, htmlFor: formField.name }, { children: [formField.label, !formField.required && _jsx("span", Object.assign({ css: optionalTextStyles }, { children: "Optional" }), void 0), formField.description && (_jsx("div", { children: _jsx("span", Object.assign({ css: fieldDescription }, { children: `(${formField.description})` }), void 0) }, void 0))] }), void 0));
